import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "bulkAction", "setAllCheckbox"]

    connect() {
        this.performBulkActionHandler = this.performBulkAction.bind(this)
        this.setAllCheckboxesHandler = this.setAllCheckboxes.bind(this)

        this.bulkActionTargets.forEach(element => {
            element.addEventListener("click", this.performBulkActionHandler)
        });

        this.setAllCheckboxTargets.forEach(element => {
            element.addEventListener("change", this.setAllCheckboxesHandler)
        })
    }

    disconnect() {
        this.bulkActionTargets.forEach(element => {
            element.removeEventListener("click", this.performBulkActionHandler)
        })

        this.setAllCheckboxTargets.forEach(element => {
            element.removeEventListener("change", this.setAllCheckboxesHandler)
        })
    }

    performBulkAction(event) {
        if (!this.hasFormTarget) return

        const button = event.currentTarget

        if (!button.dataset.turboConfirm || confirm(button.dataset.turboConfirm)) {
            const path = button.dataset.path
            const httpMethod = button.dataset.httpMethod

            this.formTarget.querySelector(`input[name="_method"]`).value = httpMethod
            this.formTarget.action = path

            this.formTarget.requestSubmit()
        }
    }

    setAllCheckboxes(event) {
        this.formTarget.querySelectorAll("input[type='checkbox']").forEach(checkbox => {
            checkbox.checked = event.currentTarget.checked
        })
    }
}
